<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="Target" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Target Tracking (Position)
                    .header-cta
            .box__body
                .draw-area.w-full
                    .box-map(v-if="load_data_status_single_target_tracking_list === 'loading'")
                        Loading(show="true")
                    template(v-else)
                    
                        //- template(v-if="territory_virtual_detail_map_history.data && territory_virtual_detail_map_history.data.length > 0 && mapHistoryLoaded")
                        template(v-if="mapLoaded")
                            l-map(v-if="vendorMap==='osm'"  ref="mapRefOSM" :id="id" :zoom="10" :center="center" :options="options" style="height: 100%;width: 100%;")
                                l-tile-layer(:url="url" :attribution="attribution")
                                l-marker(v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index" :icon="getMarkerOsmIcon(location)")
                                    l-popup(:content="location.name")
                            gmap-map(v-else ref="mapRef" :center="center" :zoom="11" :options="options" style="width:100%; height: 100%;")
                        
                        .block.box-map(v-else)
                            NoDataAvailable

        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Target List
                    .header-cta
                        router-link.btn-primary(to="/target/create")                                
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user-plus"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
                            span(style="padding-left: 8px;") Add New Target
            .box__body
                .form.px-4.py-4(
                    class="lg:py-0"
                )
                    .flex.flex-wrap.items-center.justify-between
                        .mr-0.mb-2.relative.field--search(
                            class="lg:mr-2 lg:mb-0"
                            )
                            input.field-style(id="field" type="text" v-model="keyword" placeholder="Search target here..." @keyup="searchKeyword")
                            .absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>

                        .flex.items-center.w-full(
                            class="lg:w-48"
                        )
                            span.block.mr-2 Show
                            .field.mr-2.relative.w-full
                                select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                    option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            span entries

                div.flex.items-center.justify-between.bg-gray-100.p-4(v-if='monitoringOnly')
                    span.text-sm.text-gray-600 Monitoring started at 9 maret 2020 15:00 WIB
                    button.btn-primary-o Stop All
                
                .table-static.w-full.p-4.table-mobile.table-target
                    table.table-general
                        thead
                            tr.m-hide
                                th(
                                    v-for="(th,index) in tableThead"
                                    :key="index"
                                    :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')+(th.name.toLowerCase()==='clues' || th.name.toLowerCase()==='last updated' || th.name.toLowerCase()==='clues'  || th.name.toLowerCase()==='created by' ? 'm:column-hide' : '')"
                                ) {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_single_target_list.status === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")
                                    
                            template(v-else-if="single_target_list.data && single_target_list.data.length > 0")
                                tr(v-for="(data,index) in single_target_list.data" :key="data.id").mobile-blocked
                                    td
                                        //- router-link.flex.items-center(:to="'/target/'+data.id+'/detail/'+data.id+'/home'")
                                        button.flex.items-center(@click="detailTarget(data)")
                                            .block
                                                figure.w-12.h-12.mr-4
                                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="data.photos && data.photos[0] ? data.photos[0].file : getDefaultImage" @error="getDefaultImage")
                                                    //- img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="data.photo ? data.photo : getDefaultImage" @error="getDefaultImage")
                                            .link-text.text-left {{ data.target_name }}
                                    td.target-mobile-label.w-5.text-center
                                        label(v-if="data.label" :class="[`inline-block w-4 h-4 rounded-full`]" :style="'background-color: '+ data.label +';'")
                                        span(v-else) -
                                    td(class="m:column-hide")
                                        ul
                                            li.label-gray.flex.items-center(v-for="clue in countClues(data.clues)")
                                                strong {{ clue.count }} 
                                                span(style="padding-left:2px") {{ clue.name }}
                                    td 
                                        .no-wrap-text {{ toString(data.cases) }}
                                        //- small.no-wrap-text {{ data.case.operation_name }}
                                    td 
                                        span.box-notes {{data.notes?data.notes.notes:'no notes'}}

                                    td(class="m:column-hide") 
                                        small {{ data.created_by && data.created_by.name ? data.created_by.name : '-' }}
                                    td(class="m:column-hide")  
                                        small {{ data.updated_at }}
                                    td.mobile-action-target(:class="data.status.toLowerCase()==='stop' ? 'action' : 'text-center'")
                                        div.inline-flex.items-center
                                            button.btn-icon.btn-icon-40(
                                                type="button"
                                                v-tooltip="'New Note'"
                                                @click="getNotes(true, data.id, data.target_name)"
                                            )
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-plus"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
                                            button.btn-small.btn-monitoring
                                                template(v-if="data.status.toLowerCase()==='stop'")
                                                    div(v-on:click="monitoringModal(data)" v-tooltip="'Start Monitoring'")
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 29.3334C23.3638 29.3334 29.3334 23.3638 29.3334 16C29.3334 8.63622 23.3638 2.66669 16 2.66669C8.63622 2.66669 2.66669 8.63622 2.66669 16C2.66669 23.3638 8.63622 29.3334 16 29.3334Z" stroke="#8997A9" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M12 9.83167C12 9.0405 12.8752 8.56266 13.5408 8.99049L23.1359 15.1588C23.7483 15.5525 23.7483 16.4475 23.1359 16.8412L13.5408 23.0095C12.8752 23.4373 12 22.9595 12 22.1683V9.83167Z" fill="#8997A9"/>
                                                        </svg>
                                                template(v-else)
                                                    .on-monitoring(v-on:click="monitoringAction(0,data)" v-tooltip="'Stop Monitoring'")
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z" stroke="#D71F1F" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <rect x="10.6667" y="10.6667" width="10.6667" height="10.6667" rx="1" fill="#D71F1F"/>
                                                        </svg>

                                            router-link.btn-icon.btn-icon-40.m-hide(
                                                :to="'/target/'+data.id+'/edit'" v-tooltip="'Edit'"
                                                v-if="data.status.toLowerCase()==='stop'"
                                                class="m:hidden"
                                            )
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                                                
                                            button.btn-icon.btn-icon-40.m-hide(
                                                v-tooltip="'Delete'"
                                                @click="requestDelete(data.id, data.target_name)"
                                                v-if="data.status.toLowerCase()==='stop'"
                                                class="m:hidden"
                                            )
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            tr(v-else)
                                td.text-center(:colspan="tableThead.length") No Data Available
                    .mt-5
                    vue-ads-pagination(
                        :total-items="total_data"
                        :items-per-page="items_per_page"
                        :page="page"
                        :max-visible-pages="5"
                    )
                        template(slot="buttons" slot-scope="props")
                            vue-ads-page-button(
                                v-for="(button, key) in props.buttons"
                                :key="key"
                                v-bind="button"
                                :class="{'bg-yellow-dark': button.active}"
                                @page-change="page = button.page"
                                @range-change="start = button.start; end = button.end"
                            )

    //- pop up tracker

    section(v-if="monitoringData").section-popup.section-popup--show.fixed.w-full-h.full.inset-0.flex.items-start.justify-center
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            div.flex.items-center
                                figure.w-8.h-8.mr-4
                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="monitoringData.photo ? monitoringData.photo : getDefaultImage" @error="getDefaultImage")
                                span.text-light.name-index {{ monitoringData.target_name }}
                        .header-cta
                            button.btn-icon.btn-icon-40(v-on:click="monitoringModal()")
                                .icon-btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    .block.border-b.mb-4.pb-4
                        strong.block.text-xs.uppercase.mb-4 Select MSISDN
                        div.flex.items-center.flex-wrap
                            .field.field--checkbox.mb-4(class="w-1/3" v-for="data in monitoringData.clues" v-if="data.name === 'msisdn'")
                                .wrapper-checkbox
                                    input(type="checkbox" v-model="monitoringMsisdn" :value="data.value")
                                    .ui-checkbox.flex.items-center
                                        .checkbox.flex.items-center.justify-center
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                        strong {{data.value}}

                    .block.border-b.mb-4.pb-4
                        strong.block.text-xs.uppercase.mb-4 Frequency Monitoring
                        div.flex.items-center.flex-wrap
                            .field.field--radio.mb-4(class="w-1/3" v-for="data in freqOpt")
                                .wrapper-radio
                                    input(type="radio" name="radio" v-model="monitoringFreq" :value="data.value")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong {{data.name}}

                    .flex.items-center.justify-between
                        span.text-sm.text-gray-600
                            //- Start date 10 maret 2020
                        button.btn-primary.btn-large(@click="monitoringAction(1)") Start Monitoring

    //- pop up notes
    section.section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center(
        v-bind:class="{'section-popup--show' : openNote}"
    )
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        span.text-light {{tmpTargetName}}'s Notes
                        .header-cta
                            button.btn-icon.btn-icon-40(@click="getNotes(false)")
                                .icon.btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    .pb-2
                        strong.block.text-xs.uppercase.mb-4.text-light New Note
                        div.flex.mb-2
                            .field.flex-grow
                                textarea.field-style(
                                    v-model="tmpNote"
                                    placeholder="Add new note..."
                                    style="min-height: 50px;"
                                )
                                //- v-on:keydown.enter.exact.prevent
                                //- v-on:keydown.enter.shift.exact.prevent
                                //- v-on:keyup.enter.exact="addNote"
                        div.mb-2
                            .flex.items-center.justify-end
                                template(v-if="tmpNote && tmpNote.length>0")
                                    button.btn-primary(@click="addNote") Save
                                template(v-else)
                                    button.btn.btn-primary.btn-primary--disabled(disabled="disabled" style="pointer-events:none") Save

                    .block
                        strong.block.text-xs.uppercase.mb-4.text-light History notes
                        template(v-if="load_data_status_note_target_list == 'loading'")
                            .flex.flex-wrap.items-center.justify-center
                                Spinner(show="true" size="48")

                        .list.text-light.mb-3.pb-3.border-b(v-else-if="dataNotes && dataNotes.length > 0" v-for="note in dataNotes")
                            p.mb-1 {{note.notes}}
                            small.text-right.opacity-75 {{note.created_at?datetimeFormat(note.created_at, 'DD MMMM YYYY HH:mm:ss [WIB]'):'-'}} • added by {{note.created_by?note.created_by:'-'}}

                        .flex.flex-wrap.items-center.justify-center(v-else)
                            strong.block.text-xs.uppercase.text-gray-600.mb-4 No History Available
                    .block                            
                        template(v-if="load_data_status_note_target_list != 'loading' && (dataNotes && dataNotes.length > 0)")
                            small(v-if="!isLoadingNext") {{dataNotes.length}} of {{totalNotes}} items
                            .flex.flex-wrap.items-center.justify-center
                                template(v-if="isLoadingNext")
                                    Spinner(show="true" size="48")
                                template(v-else)
                                    template(v-if="pageNotes<totalPageNotes")
                                        button.btn-small.btn-primary(@click="handleNextNotes") Load More                            

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import { encrypt } from '@/util/crypto';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { gmapApi } from 'vue2-google-maps';
import moment from 'moment';

// openmapstreet
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
    name: 'PageTargetIndex',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        Loading,
        NoDataAvailable,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Target',
                    url: '/target',
                },
            ],
            monitoringData: null,
            monitoringMsisdn: [],
            monitoringFreq: 'every30minutes',
            freqOpt: this.$store.getters.getFreqMonitoring,
            monitoringOnly: false,
            popupShowMonitoring: false,
            tableThead: [
                {
                    name: 'Target',
                },{
                    name: 'Label',
                },{
                    name: 'Clues',
                },{
                    name: 'Operation Name',
                },{
                    name: 'Latest Note',
                },{
                    name: 'Created By',
                },{
                    name: 'Last Updated',
                },{
                    name: '',
                    action: true,
                },
            ],
           
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,
            defaultImage: this.$store.getters.getDefaultImage,

            // map
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}]
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}]
                    }
                ],
            },
            infoWindows: [],
            mapLoaded: false,
            // popupShow: false,
            center: {},
            markers: [],
            // places: [],
            // heatmap: null,
            mapsLatLng: [],
            polyline: null,

            marker_color: {
                green: '#48bb78',
                red: '#f56565',
                purple: '#9f7aea',
                orange: '#ed8936',
                blue: '#4299e1',
            },

            openNote: false,

            tmpTargetId: null,
            tmpTargetName: null,
            tmpNote: null,

            dataNotes: [],
            pageNotes: 0,
            totalPageNotes: 1,
            limitNotes: 10,
            totalNotes: 0,
            
            isLoadingNext: false,
            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined || typeof process.env.VUE_APP_VENDOR_MAP!=='undefined'? process.env.VUE_APP_VENDOR_MAP: 'gmap'),

            // openmapstreet
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: [],
            id: 'openmapstreet-index_target',
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),
        }
    },
    computed: {
        ...mapState([
            'load_data_status_single_target_list',
            'load_data_status_single_target_tracking_list',
            'single_target_list',
            'single_target_tracking_list',
            'load_data_status_note_target_list',
            'note_target_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        google: gmapApi,
    },
    watch: {
        route_name(newData, oldData) {
            // console.log('newData index target')
            // console.log(newData)
            // console.log(oldData)
            // if (newData === 'PageTargetIndex') {
            //     this.getData();
            // }

            if (newData === 'PageTargetIndex') {
                if (oldData !== 'PageTargetIndex') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setSingleTargetList', {});
                }
                
                this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
                this.getData();
                this.$store.dispatch('getSingleTargetTrackingList');
            }
        },
        google() {},
        single_target_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            // console.log('item_pp target')
            this.getData();
            // this.pagination();
        },
        page() {
            // console.log('page target')
            this.getData();
        },
        keyword() {},
        single_target_tracking_list(newData) {
            // console.log(newData)
            if (newData.length > 0)
                this.startMap();
        },
        note_target_list(newData){
            // console.log('newData')
            // console.log(newData)
            if (Object.keys(newData).length > 0) {
                // console.log('masuk')
                this.dataNotes = this.dataNotes.concat(newData.data);
                this.totalNotes = parseInt(newData.total_data);
                this.limitNotes = parseInt(newData.per_page);
                this.pageNotes = parseInt(newData.current_page);
                this.totalPageNotes = parseInt(newData.total_page);
            } else {
                this.setDefaulDataNotes()
                // console.log('else')
                // this.dataNotes = [];
                // this.totalNotes = 0;
                // this.limitNotes = 10;
                // this.pageNotes=0;
                // this.totalPageNotes=1;
            }
            this.isLoadingNext=false
        },
    },
    methods: {
        checkMsisdn(data) {
            var msisdn = data.clues.filter(function (clue) {
                return clue.name === 'msisdn'
            })
            return msisdn
        },
        detailTarget(data) {
            var msisdn = this.checkMsisdn(data)
            if (msisdn.length > 0) {
                this.$router.push({ name: 'PageTargetDetailHome', params: { id: data.id ,key: encrypt(msisdn[0].value + '&&msisdn') }  })
            } else {
                this.error('Target does not have a MSISDN clue')
            }
        },
        monitoringAction(status=1,data=null) {
            if(data==null){
                data=this.monitoringData
            }
            var title = 'Are you sure you want to start monitoring ?'
            if (status === 0) {
                title = 'Are you sure you want to stop monitoring?'
            }
            this.$swal.fire({
                icon: 'warning',
                title: title,
                text: 'Single Target : ' + data.target_name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    // console.log(result.value);

                    this.showLoading(true);

                    this.$store.dispatch('postMonitoring', [data.id, status, [JSON.stringify(this.monitoringMsisdn)], this.monitoringFreq])
                    .then((resp) => {
                        // console.log('postMonitoring');
                        // console.log(resp);
                        if (resp.result === 'success') {
                            this.page = 0;
                            this.monitoringModal();

                            this.getData();

                            this.$swal.fire({
                                icon: 'success',
                                title: resp.data.message,
                                timer: 3000,
                            });
                        } else {
                            if (resp.data.message) {
                                this.error(resp.data.message);
                            } else {
                                this.error();
                            }
                        }
                    });
                }
            });
        },
        monitoringModal(item=null) {
            this.monitoringMsisdn= []
            this.monitoringFreq= 'every30minutes'
            if (item) {            
                var msisdn = this.checkMsisdn(item)
                if (msisdn.length > 0) {
                    this.monitoringData = item
                    this.popupShowMonitoring = !this.popupShowMonitoring
                } else {
                    this.error('Target does not have a MSISDN clue')
                }
            } else {            
                this.monitoringData = item
                this.popupShowMonitoring = !this.popupShowMonitoring
            }
        },

        toString(array) {
            if (array.length > 0) {            
                return Object.keys(array).map(function(k){
                    return array[k].operation_name
                }).join(", ")
            } else {
                return '-'
            }
        },
        countClues(array) {
            var ret = {}
            if (this.single_target_list.data && this.single_target_list.data.length > 0) {
                for (let i in array) {
                    let key = array[i].name
                    ret[key] = {
                        name: key,
                        count: ret[key] && ret[key].count ? ret[key].count + 1 : 1
                    }
                }
                return Object.values(ret)
            }
            return Object.values(ret)
        },
        getData() {
            this.$store.commit('setTargetRedirect', 'index');
            // console.log('=================== getData() route on target')
            // console.log(this.route_name);

            // for dispatch get data

            this.$store.dispatch('getSingleTargetList', [this.items_per_page, (this.page + 1), this.keyword]);

            // if (this.case_management_list.total_page && this.case_management_list.total_page > 1) {
                // console.log(this.case_management_list.total_page)
                this.pagination();
            // }

            // this.getMapTracking();
            // this.$store.dispatch('getSingleTargetTrackingList');
            // this.startMap();
        },
        // getMapTracking() {
        //     this.$store.dispatch('getSingleTargetTrackingList');
        // },
        requestDelete(id, name) {
            // console.log(id)
            this.showLoading(true);

            this.$store.dispatch('getSingleTargetDelete', [id, true])
            .then((resp) => {
                if (resp === 'success') {
                    this.page = 0;

                    this.getData();

                    this.$swal.fire({
                        icon: 'success',
                        title: 'Data successfully deleted!',
                        timer: 3000,
                    });
                } else {
                    // console.log(resp)
                    if (resp.data && resp.data.message && resp.data.message === 'next-delete') {
                        this.deleteData(resp.data.data.id, resp.data.data.target_name)

                    } else if (resp.data.conclusion) {
                        if (typeof resp.data.force != 'undefined' && resp.data.force === true) {
                            // console.log('force = true')
                            let errors = '';
                            if (resp.data.messages && resp.data.messages.length > 0) {
                                // errors = errors + '<div class="swal2-html-container mt-2" style="display: block;">' + 'Single Target : ' + name + '<div>';
                                errors = errors + '<section class="container-alert"><div class="container-alert__list">' + 'SingleTarget : ' + name + '</div>';

                                Object.keys(resp.data.messages).forEach(function (item) {
                                    // errors += resp.data.messages[item] + '<br><br>';
                                    // errors += '<div class="swal2-html-container" style="display: block;">' + resp.data.messages[item] + '<br><div>';
                                    errors = errors + '<div class="container-alert__list">' + resp.data.messages[item] + '</div>';
                                });
                                errors = errors + '</section>';
                            }

                            this.$swal.fire({
                                icon: 'warning',
                                title: resp.data.conclusion,
                                // text: id,
                                text: 'Single Target : ' + name,
                                html: errors,
                                confirmButtonText: 'Yes!',
                                confirmButtonColor: '#DD6B55',
                                showCancelButton: true,
                                allowOutsideClick: false,
                            })
                            .then((result2) => {
                                // console.log('on result2');
                                if (result2.isConfirmed) {
                                    this.showLoading(true);

                                    this.$store.dispatch('getSingleTargetDelete', [id, false, true])
                                    .then((resp2) => {
                                        if (resp2 === 'success') {
                                            this.page = 0;

                                            this.getData();

                                            this.$swal.fire({
                                                icon: 'success',
                                                title: 'Data successfully deleted!',
                                                timer: 3000,
                                            });
                                        } else {
                                            console.log(resp2)

                                            if (resp2.data.message) {
                                                this.error(resp2.data.message);
                                            } else {
                                                this.error();
                                            }
                                        }
                                    });
                                }
                            });

                        } else {
                            
                            resp.data.messages.unshift('Single Target : ' + name);
                            this.error(null, resp.data.conclusion, resp.data.messages);
                        }

                    } else {
                        if (resp.data.message) {
                            this.error(resp.data.message);
                        } else {
                            this.error();
                        }
                    }

                }
            });
        },
        deleteData(id, name) {
            // console.log(id)
            this.$swal.fire({
                icon: 'warning',
                // title: 'Are you sure you want to delete data?',
                title: 'Are you sure you want to delete?',
                // text: id,
                text: 'Single Target : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    // console.log(result.value);

                    this.showLoading(true);

                    this.$store.dispatch('getSingleTargetDelete', [id])
                    .then((resp) => {
                        if (resp === 'success') {
                            this.page = 0;

                            this.getData();

                            this.$swal.fire({
                                icon: 'success',
                                title: 'Data successfully deleted!',
                                timer: 3000,
                            });
                        } else {

                            if (resp.data.message) {
                                this.error(resp.data.message);
                            } else {
                                this.error();
                            }
                        }
                    });
                }
            });
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setSingleTargetList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        hideAllInfoWindows() {
            for (var j=0; j < this.infoWindows.length; j++) {
                this.infoWindows[j].close();
            }
        },
        getMarkerOsmIcon(location){
            let iconColor = '#ffffff'
            if (location.iconColor){
                iconColor = location.iconColor
            }
            let stroke_width = '1.4';
            let stroke = 'black';
            // let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="black" stroke-width="3"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="black" stroke-width="3" stroke-linejoin="round"/></svg>'
            let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="'+ stroke +'" stroke-width="'+ stroke_width +'"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="'+ stroke +'" stroke-width="'+ stroke_width +'" stroke-linejoin="round"/></svg>'
            // let myIconUrl = encodeURI("data:image/svg+xml," + mySvgString).replace('<color-icon>',iconColor).replace('#','%23');
            // let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replaceAll('<color-icon>',iconColor)).replaceAll('#','%23');
            let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replace(/<color-icon>/g,iconColor)).replace(/#/g,'%23');

            return L.icon({
                iconUrl: myIconUrl,
                // iconSize: 40
                iconSize: 50,
                iconAnchor: [24.5, 49],
                popupAnchor: [0, -48],
            });
        },
        async startMap() {
            switch(this.vendorMap) {
              case 'osm':
                await this.startMapOSM();
                break;
              default:
                await this.startMapGMAP();
                break;
            }
        },
        async startMapGMAP() {
            var self = this;
            // var mapsLatLng = [];
            self.infoWindows = [];
            self.markers = [];
            self.mapsLatLng = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                self.$refs.mapRef.$mapPromise.then((map) => {
                    const google = self.google;

                    map.center = new google.maps.LatLng(self.center);

                    // console.log(self.single_target_tracking_list.length);

                    if (self.single_target_tracking_list.length > 0) {
                        var bounds = new google.maps.LatLngBounds();

                        for (var i = 0; i < self.single_target_tracking_list.length; i++) {

                            if (Object.keys(self.single_target_tracking_list[i].data).length > 0) {

                                var icon = {
                                    path: 'M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z',
                                    // fillColor: self.marker_color[self.single_target_tracking_list[i].target.label],
                                    fillColor: self.single_target_tracking_list[i].target.label,
                                    fillOpacity: 1,
                                    // strokeWeight: 1.2,
                                    strokeWeight: 1.2,
                                    strokeColor: '#ffffff',
                                    // scale: 1.25,
                                    scale: .65,
                                    anchor: new google.maps.Point(30,65),
                                }

                                let marker = new google.maps.Marker({
                                    position: {
                                        lat: parseFloat(self.single_target_tracking_list[i].data.lat),
                                        lng: parseFloat(self.single_target_tracking_list[i].data.lng)
                                    },
                                    map: map,
                                    icon: icon,
                                    // draggable: true,
                                });
                                // console.log(marker);
                                self.markers.push(marker);

                                // var dtm = (self.tactical_devices_map_location[i].created_at ? self.datetimeFormat(self.tactical_devices_map_location[i].created_at) : '-');
                                
                                var contentString = '<div id="content">'+
                                    '<div id="bodyContent">'+
                                        '<table>'+
                                            '<tr>'+
                                                '<td class="pr-1 cell-info-window whitespace-no-wrap">Target Name</td>'+
                                                '<td class="pr-1 cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+self.single_target_tracking_list[i].target.name+'</td>'+
                                            '</tr>'+
                                            '<tr>'+
                                                '<td class="cell-info-window whitespace-no-wrap">MSISDN</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+(self.single_target_tracking_list[i].msisdn ? self.single_target_tracking_list[i].msisdn : '-')+'</td>'+
                                            '</tr>'+
                                            '<tr>'+
                                                '<td class="cell-info-window whitespace-no-wrap">Address</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+(self.single_target_tracking_list[i].data.address ? self.single_target_tracking_list[i].data.address : '-')+'</td>'+
                                            '</tr>'+
                                            // '<tr>'+
                                            //   '<td class="cell-info-window">Datetime</td>'+
                                            //   '<td class="cell-info-window">:</td>'+
                                            //   '<td class="cell-info-window">'+dtm+'</td>'+
                                            // '</tr>'+
                                            '<tr>'+
                                                '<td class="cell-info-window whitespace-no-wrap">Link Location</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.single_target_tracking_list[i].data.lat+','+self.single_target_tracking_list[i].data.lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                                '</td>'+
                                            '</tr>'+
                                        '</table>'+
                                    '</div>'+
                                '</div>';

                                let infowindow = new google.maps.InfoWindow({
                                    content: contentString,
                                    maxWidth: 400
                                });
                                
                                self.infoWindows.push(infowindow);
                                
                                google.maps.event.addListener(marker, 'click', function() {
                                    // hideAllInfoWindows(map);
                                    self.hideAllInfoWindows();
                                    infowindow.open(map, marker);
                                    // console.log(marker.position.lat(), marker.position.lng())
                                });

                                bounds.extend(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
                            }

                        }
                        // Apply fitBounds
                        map.fitBounds(bounds); 
                    }
                });
            });
        },
        async startMapOSM() {
            var self = this;
            // var mapsLatLng = [];
            self.locations = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };
            this.mapLoaded = true;

            await self.$nextTick(() => {
                const map = self.$refs.mapRefOSM.mapObject

                    if (self.single_target_tracking_list.length > 0) {
                        var bounds = [];
                        
                        for (var i = 0; i < self.single_target_tracking_list.length; i++) {

                            if (Object.keys(self.single_target_tracking_list[i].data).length > 0) {
                                let latTmp = parseFloat(self.single_target_tracking_list[i].data.lat);
                                let lngTmp = parseFloat(self.single_target_tracking_list[i].data.lng);
                                
                                var contentString = '<div id="content">'+
                                    '<div id="bodyContent">'+
                                        '<table>'+
                                            '<tr>'+
                                                '<td class="pr-1 cell-info-window whitespace-no-wrap">Target Name</td>'+
                                                '<td class="pr-1 cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+self.single_target_tracking_list[i].target.name+'</td>'+
                                            '</tr>'+
                                            '<tr>'+
                                                '<td class="cell-info-window whitespace-no-wrap">MSISDN</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+(self.single_target_tracking_list[i].msisdn ? self.single_target_tracking_list[i].msisdn : '-')+'</td>'+
                                            '</tr>'+
                                            '<tr>'+
                                                '<td class="cell-info-window whitespace-no-wrap">Address</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+(self.single_target_tracking_list[i].data.address ? self.single_target_tracking_list[i].data.address : '-')+'</td>'+
                                            '</tr>'+
                                            // '<tr>'+
                                            //   '<td class="cell-info-window">Datetime</td>'+
                                            //   '<td class="cell-info-window">:</td>'+
                                            //   '<td class="cell-info-window">'+dtm+'</td>'+
                                            // '</tr>'+
                                            '<tr>'+
                                                '<td class="cell-info-window whitespace-no-wrap">Link Location</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.single_target_tracking_list[i].data.lat+','+self.single_target_tracking_list[i].data.lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                                '</td>'+
                                            '</tr>'+
                                        '</table>'+
                                    '</div>'+
                                '</div>';
                                let centerTmp = [latTmp, lngTmp]
                                self.locations.push({name:contentString,position:centerTmp, iconColor:self.single_target_tracking_list[i].target.label})

                                bounds.push(centerTmp);
                            }

                        }

                        if (bounds.length){
                            map.fitBounds(L.latLngBounds([bounds]))
                        }
                    }
            });
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        // error(message=null) {
        //     this.$swal.fire({
        //         title: 'Failed!',
        //         text: (message!==null ? message : 'Something wrong.'),
        //         icon: 'error',
        //         // timer: 3000
        //     });
        // },
        error(message=null, title=null, data=null) {
            let errors = '';

            if (data !== null) {
                errors = errors + '<section class="container-alert">';
                Object.keys(data).forEach(function (item) {
                    // errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<br><div>';
                    // errors = errors + '<div class="swal2-html-container mt-2" style="display: block;">' + data[item] + '<div>';
                    errors = errors + '<div class="container-alert__list">' + data[item] + '</div>';
                });
                errors = errors + '</section>';
            }

            this.$swal.fire({
                icon: 'error',
                title: (title!==null ? title : 'Failed!'),
                text: (message!==null ? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        }, 
        getNotes(open=true, target_id=null,target_name=null) {
            this.$store.commit('setNoteTargetList', {});
            if(open){
                this.tmpTargetId = target_id
                this.tmpTargetName = target_name
                this.$store.dispatch('getNoteTargetList', [true, this.tmpTargetId, this.limitNotes, this.pageNotes+1]);
                this.openNote = true
            } else {
                this.setEmptyNotes() 
            }
        },
        handleNextNotes(){
            this.isLoadingNext=true
            this.$store.dispatch('getNoteTargetList', [false, this.tmpTargetId, this.limitNotes, this.pageNotes+1]);
        },
        addNote(){
            this.showLoading(true);
            this.$store.dispatch('getNoteTargetCreate', [this.tmpTargetId, this.tmpNote])
                .then((resp) => {
                    if (resp === 'success') {
                        // this.getNotes(false)
                        this.tmpNote = null
                        this.setDefaulDataNotes()

                        this.getNotes(true, this.tmpTargetId, this.tmpTargetName);
                        this.getData();

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Note successfully added!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message) {
                            this.error(resp.data.message);
                        } else {
                            this.error();
                        }
                    }
                });
        },
        setEmptyNotes(){
            this.tmpTargetId = null
            this.tmpTargetName = null
            this.tmpNote = null
            this.openNote = false
        },
        setDefaulDataNotes(){
            this.dataNotes = [];
            this.totalNotes = 0;
            this.limitNotes = 10;
            this.pageNotes=0;
            this.totalPageNotes=1;
        },
        datetimeFormat(datetime, format="DD MMM YYYY HH:mm:ss") {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format(format);
        },
    },
    mounted() {
        // console.log('=================== mounted on target index')
        if (this.route_name === 'PageTargetIndex') {
            // this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });

            this.getData();
            this.$store.dispatch('getSingleTargetTrackingList');
        }
    },
    // destroyed() {
    //     this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
    // },
}
</script>

<style lang="sass">
@media screen and ( max-width: 480px)
    .table-mobile
        padding: 0px
    .table-target
        border: 0px !important
    .field--search
        width: 100%

    .mobile-blocked
        display: block
        border-bottom: 1px solid $color-border
        padding: 6px 0px
        position: relative
        &:hover
            td
                background-color: transparent !important
        td 
            display: block
            width: 100%
            border-bottom: 0px !important
            padding: 0px
            .box-notes
                display: block
                max-width: 100%
                white-space: normal

            &.m\:column-hide
                display: none !important
            &.target-mobile-label
                position: absolute
                left: 40px
                top: 40px
                width: 20px
                height: 20px
            &.mobile-action-target
                position: absolute
                right: 10px
                top: 0px
                width: 80px
                display: flex
                align-items: center
                justify-content: center
                .btn-monitoring
                    margin-left: 0px !important

%nowrap-text
    text-overflow: ellipsis
    white-space: nowrap
    display: block
    overflow: hidden
    
.name-index
    width: 150px
    @extend %nowrap-text

.no-wrap-text
    max-width: 250px
    @extend %nowrap-text

.table-static table .btn-monitoring
    div
        opacity: 1
    .btn-status
        width: 32px
        height: 32px
        display: flex
        align-items: center
        justify-content: center
        opacity: 1
        background-color: transparent
        border-radius: 100%
        border: 1px solid #e2e8f0
        &.is-stop
            border-color: #ff5722
            color: #ff5722
            background-color: transparent
            &:hover
                background-color: rgba(255, 87, 34, 0.14)
                
        &.is-play
            background-color: transparent
            border-color: #40bb5b
            color: #40bb5b
            &:hover
                background-color: rgba(64, 187, 91, 0.14)

.container-alert
        border: 1px solid #a0aec0
        border-radius: 4px
        background-color: #f7fafc
        &__list
            border-bottom: 1px solid #a0aec0
            border-radius: 4px
            text-align: left
            font-size: 16px
            line-height: 24px
            padding: 1rem
            &:last-child
                margin-bottom: 0px
                border-bottom: 0px
</style>
